import { useQuery } from '@apollo/client/react';
import { Avatar } from '@mui/material';
import { SITE_QUERY } from 'graphql-local/getSite';

const SiteAvatar = props => {
  const { siteid } = props
  let imageUrl = ''
  const { loading, error, data } = useQuery(SITE_QUERY, {
    variables: { siteid }
  });
  if (loading) return <div>Fetching</div>
  if (error) return <div>Error</div>
  const { site } = data  
  if (site.domain_name) {
    imageUrl = `${import.meta.env.VITE_HTTP}://${siteid}.${site.domain_extension}${import.meta.env.VITE_SITE_PROFILE_PATH_WITH_DOMAIN}${siteid}/images/ui/site.logo`
  } else {
    imageUrl = `${import.meta.env.VITE_HTTP}://${siteid}${import.meta.env.VITE_SITE_PROFILE_PATH}${siteid}/images/ui/${site.logo}`
  }
return (
    <Avatar src={imageUrl}></Avatar>
  )
}

export default SiteAvatar